import { render, staticRenderFns } from "./OrCriteriaSummary.vue?vue&type=template&id=092b49f8&scoped=true"
import script from "./OrCriteriaSummary.vue?vue&type=script&lang=js"
export * from "./OrCriteriaSummary.vue?vue&type=script&lang=js"
import style0 from "./OrCriteriaSummary.vue?vue&type=style&index=0&id=092b49f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b49f8",
  null
  
)

export default component.exports